export default function PlaybackIcon(props) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33398 3.32667C3.33398 2.67922 3.33398 2.3555 3.46898 2.17706C3.58658 2.0216 3.76633 1.9254 3.96092 1.91378C4.18427 1.90044 4.45363 2.08001 4.99233 2.43915L12.0027 7.11273C12.4478 7.40948 12.6704 7.55785 12.7479 7.74487C12.8158 7.90837 12.8158 8.09213 12.7479 8.25563C12.6704 8.44264 12.4478 8.59102 12.0027 8.88777L4.99233 13.5614C4.45363 13.9205 4.18427 14.1001 3.96092 14.0867C3.76633 14.0751 3.58658 13.9789 3.46898 13.8234C3.33398 13.645 3.33398 13.3213 3.33398 12.6738V3.32667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
